import { inject } from '@angular/core';
import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// Enum
import { TypeStore } from '../common/enums/general/TypeStore';

// Service
import { StorageService } from '../Services/storage.service';

export const tokenInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const storage = inject(StorageService);
  const token = storage.read(TypeStore.TOKEN);

  if (token) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }

  return next(req).pipe(
    map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse && event.headers.has('Authorization')) {
        const authHeader = event.headers.get('Authorization')!;
        const newToken = authHeader.replace(/^Bearer\s+/, '');
        storage.save(TypeStore.TOKEN, newToken);
      }
      return event;
    })
  );
};
